module.exports = __webpack_public_path__ + "img/exhibition.fefab63c.svg";